(() => {
  const selector = '[data-carisma-footer]';
  if (window.CarismaFooter) {
    window.CarismaFooter.mount(document);
    return;
  }

  const instances = new WeakMap();
  class FooterNavigation {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.mobile = matchMedia('(max-width: 700px)');
      this.menus = [...root.querySelectorAll('[data-footer-menu]')];
      this.mobileOpen = null;
      this.on = (element, event, callback) => element.addEventListener(event, callback, { signal: this.abort.signal });
      this.menus.forEach((menu) => {
        const summary = menu.querySelector('summary');
        this.on(summary, 'click', (event) => {
          if (!this.mobile.matches) event.preventDefault();
        });
        this.on(menu, 'toggle', () => {
          if (!this.mobile.matches) return;
          if (menu.open) {
            this.mobileOpen = menu;
            this.menus.forEach((other) => {
              if (other !== menu) other.open = false;
            });
          } else if (this.mobileOpen === menu) {
            this.mobileOpen = null;
          }
        });
      });
      this.on(this.mobile, 'change', () => this.sync());
      this.sync();
    }

    sync() {
      this.menus.forEach((menu) => {
        menu.open = !this.mobile.matches || menu === this.mobileOpen;
        const summary = menu.querySelector('summary');
        if (this.mobile.matches) summary.removeAttribute('tabindex');
        else summary.setAttribute('tabindex', '-1');
      });
    }

    select(block) {
      const menu = block?.querySelector('[data-footer-menu]');
      if (!menu || !this.mobile.matches) return;
      this.mobileOpen = menu;
      this.sync();
    }

    destroy() {
      this.abort.abort();
    }
  }

  function roots(scope) {
    return [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  }
  function mount(scope) {
    roots(scope).forEach((root) => {
      if (!instances.has(root)) instances.set(root, new FooterNavigation(root));
    });
  }
  window.CarismaFooter = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    roots(event.target).forEach((root) => {
      instances.get(root)?.destroy();
      instances.delete(root);
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest(selector);
    instances.get(root)?.select(event.target);
  });
})();
